module.exports = __webpack_public_path__ + "img/4.3d8c721b.png";